import type { Kinerja } from 'types/kinerja'
import type { ResolvedPerencanaanData } from 'app/KinerjaGpkPage/types/perencanaan'

export function resolvePerencanaanData(data: Kinerja): ResolvedPerencanaanData {
  if (!data) {
    return {
      tugasTambahanId: null,
      praktikKinerjaId: null,
      pengembanganKompetensiId: null,
      perilakuKerjaItems: null,
    }
  }

  return {
    // Safely get the first item of the `tugasTambahan` array
    // since it always have only 1 item
    tugasTambahanId: data.tugasTambahan?.[0]?.id,
    // Use praktik pembelajaran id as praktik kinerja id
    praktikKinerjaId: data.praktikPembelajaran,
    // Safely get the first item of the `pengembanganKompetensi` array
    // since it always have only 1 item
    pengembanganKompetensiId: data.pengembanganKompetensi?.[0]?.id,
    perilakuKerjaItems: data.prilakuKerja,
  }
}
